const getCorrectedPhoneNumbers = function (state, getters) {
  return function(collection: any[], isUnderGhl: boolean = true) {
    if (!isUnderGhl) {
      collection = getters.getSortedPhoneNumbers(collection)
    }
    const augmentedCollection = getters.getAugmentedPhoneNumbers(collection)

    return augmentedCollection
  }
}

export default getCorrectedPhoneNumbers
